import axios from 'axios'

// Get API base URL from environment variable or use relative path for development
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL || ''}/api`

console.log('[API Client] Using API base URL:', API_BASE_URL)

// Create axios instance
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 seconds - increased from 10s to handle slow operations like document creation with audit logging
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Note: Trailing slash handling removed - FastAPI routes may require specific slash behavior
    // Let each service define its own URL format

    // Add auth token if available
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('[API Client] Request interceptor error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log('[API Client] Response received:', response.status, response.config.url)
    return response
  },
  (error) => {
    const status = error.response?.status
    const url = error.config?.url
    const errorData = error.response?.data

    // Log full error details for debugging
    console.error('[API Client] Response error:', {
      status,
      url,
      hasAuthHeader: !!error.config?.headers?.Authorization,
      errorData: errorData,
      errorType: typeof errorData,
      isArray: Array.isArray(errorData)
    })

    if (status === 401) {
      // Handle unauthorized access
      console.error('[API Client] 401 Unauthorized - clearing token and redirecting to login')
      localStorage.removeItem('token')
      window.location.href = '/login'
    } else if (status === 403) {
      console.error('[API Client] 403 Forbidden - user lacks required permissions')
      console.error('[API Client] Error details:', errorData)
    } else if (status === 422) {
      // Validation error
      console.error('[API Client] 422 Validation Error:', errorData)
    } else if (status >= 500) {
      console.error('[API Client] Server error (5xx). Please try again later.')
    } else if (errorData) {
      // Log the actual error data structure
      const message = errorData.detail || errorData.message || JSON.stringify(errorData)
      console.error('[API Client] API Error:', message)
    }

    return Promise.reject(error)
  }
)

export default apiClient